import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/formularios.css';
import '../styles/styles.css';
import logoInstituto from '../components/images/logo.png';
import logoSEP from '../components/images/SEP_Logo_2019.svg.png.jpg';
import { useLocation, useNavigate } from 'react-router-dom';


const ModificarCoordinador = () => {
  const navigate = useNavigate();
    const location = useLocation();
    const handleSalir = () => {
      const rol = resolveRolBase(location.pathname);
      if (rol) {
        navigate(`/${rol}/inicio`, { replace: true });
      } else {
        // Fallback por si no se detecta rol ni en path ni en localStorage:
        navigate('/inicio', { replace: true });
      }
    };

  return (
    <div className="container py-4 px-4">
      {/* Encabezado */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <img src={logoInstituto} alt="Logo Instituto" className="logo" />
        <div className="flex-grow-1 text-center">
          <h4 className="mb-0">Instituto Silviano Carrillo</h4>
          <small className="text-muted fs-5">Modificar Coordinador</small>
        </div>
        <img src={logoSEP} alt="Logo SEP" className="logo" />
      </div>

      {/* Formulario en modo lectura */}
      <div className="p-4 bg-light rounded shadow-sm">
        <form className="row g-3">
          <div className="col-md-3">
            <label className="form-label">ID Coordinador</label>
            <input type="text" className="form-control" readOnly disabled />
          </div>

          <div className="col-md-3">
            <label className="form-label">Tipo de Usuario</label>
            <input type="text" className="form-control" readOnly disabled />
          </div>

          <div className="col-md-6">
            <label className="form-label">Nombre</label>
            <input type="text" className="form-control" readOnly />
          </div>

          <div className="col-md-3">
            <label className="form-label">Apellido Paterno</label>
            <input type="text" className="form-control" readOnly />
          </div>

          <div className="col-md-3">
            <label className="form-label">Apellido Materno</label>
            <input type="text" className="form-control" readOnly />
          </div>

          <div className="col-md-2">
            <label className="form-label">Sexo</label>
            <select className="form-select" disabled>
              <option>Femenino</option>
              <option>Masculino</option>
              <option>Otro</option>
            </select>
          </div>

          <div className="col-md-4">
            <label className="form-label">Teléfono</label>
            <input type="text" className="form-control" readOnly />
          </div>

          <div className="col-md-6">
            <label className="form-label">Correo</label>
            <input type="email" className="form-control" readOnly />
          </div>

          <div className="col-md-6">
            <label className="form-label">Fecha de Nacimiento</label>
            <input type="date" className="form-control" readOnly />
          </div>

          <div className="col-md-6">
            <label className="form-label">Puesto</label>
            <input type="text" className="form-control" readOnly />
          </div>
          {/* Botones */}
          <div className="d-flex justify-content-center gap-3 mt-4">
            <button className="btn btn-warning px-4">Modificar</button>
            <button type="button" className="btn btn-danger px-4" onClick={handleSalir}>
             Salir
            </button>
          </div>
        </form>
      </div>

      
    </div>
  );
};
/* ----------------- Helper para detectar el rol ----------------- */
function resolveRolBase(pathname) {
  // 1) Intenta desde la URL actual
  const roles = ['directora', 'coordinadora', 'docente', 'alumno'];
  const seg = pathname.split('/').filter(Boolean)[0];
  if (roles.includes(seg)) return seg;

  // 2) Respaldo desde localStorage.role (números mapeados a slugs)
  const roleId = Number(localStorage.getItem('role'));
  const map = { 1: 'directora', 2: 'coordinadora', 3: 'docente', 4: 'alumno' };
  return map[roleId] || null;
}

export default ModificarCoordinador;
